/**
 * §7.6 — the marketplace is empty at launch, so an empty state is a designed
 * screen, not a fallback. Copy comes from `EMPTY_STATES` in @pm/shared; this
 * component only lays it out and attaches the route the copy's CTA implies.
 */

import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

export function EmptyState({
  heading,
  body,
  cta,
  tone = 'neutral',
  children,
}: {
  heading?: ReactNode;
  body?: ReactNode;
  cta?: { label: string; to?: string; onClick?: () => void };
  tone?: 'neutral' | 'warn' | 'bad';
  children?: ReactNode;
}) {
  return (
    <div className={`empty empty-${tone}`}>
      {heading ? <h3 className="empty-heading">{heading}</h3> : null}
      {body ? <p className="empty-body">{body}</p> : null}
      {children}
      {cta ? (
        cta.to ? (
          <Link className="btn btn-primary" to={cta.to}>
            {cta.label}
          </Link>
        ) : (
          <button type="button" className="btn btn-primary" onClick={cta.onClick}>
            {cta.label}
          </button>
        )
      ) : null}
    </div>
  );
}
